import httpClient from './httpClient';


const getUnit =  () => httpClient.get('/RentalUnits?page=1&pageSize=10000').then(
  (data) => data
)
  .catch(()=>{
    //
  })
const setUnit =  (params) => httpClient.post('/RentalUnits', {
  area: params.area,
  phoneNo: params.phoneNo,
  unitCategory: params.unitCategory,
  devolutionCategory: params.devolutionCategory,
  mortgageCost: params.mortgageCost,
  rentCost: params.rentCost,
  buyCost: params.buyCost,
  floor: params.floor,
  plate: params.plate,
  file:params.imgPath
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putUnit = (params,id) => httpClient.put(`/RentalUnits/${id}`, {
  id:id,
  area: params.area,
  phoneNo: params.phoneNo,
  unitCategory: params.unitCategory,
  devolutionCategory: params.devolutionCategory,
  mortgageCost: params.mortgageCost,
  rentCost: params.rentCost,
  buyCost: params.buyCost,
  floor: params.floor,
  plate: params.plate,
  file:params.imgPath
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putUnitImage = (params,id) => httpClient.put(`/RentalUnits/${id}`, {
  id:id,
  area: params.area,
  phoneNo: params.phoneNo,
  unitCategory: params.unitCategory,
  devolutionCategory: params.devolutionCategory,
  mortgageCost: params.mortgageCost,
  rentCost: params.rentCost,
  buyCost: params.buyCost,
  floor: params.floor,
  plate: params.plate,
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const  deleteUnit= (id) => httpClient.delete(`/RentalUnits/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export {
  getUnit,
  setUnit,
  putUnit,
  deleteUnit,
  putUnitImage,
  // getUser,
  // createUser
}
